<template>
  <div class="home">
    <h1>Convalida prodotto</h1>
    <hr>
    
    <h3>Codice {{ code  }}</h3>

    <div class="d-flex my-4" v-if="loading">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <span class="ms-2">Caricamento in corso</span>
    </div>


    <div v-if="validation_response" :class="'mt-4 alert ' + ( validation_response.success ? 'alert-success' : 'alert-danger')"  v-html="validation_response.message"></div>

  </div>
</template>

<script>
// @ is an alias to /src

import CmMixin from '../../../webapp/src/mixins/CmMixin'
// import CmMixin from '../mixins/CmMixin'

export default {
  mixins: [ CmMixin ],
  name: 'Validate',
  props: {
    id: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    }
  },
  data: () => {
		return {
      loading: false,
      validation_response: null,
			
		}
	},
  mounted: function(){

    this.validateWarranty();
  },
  methods:{



    validateWarranty: function( callback ){
       
      var self = this;

      var post_data = {
        id: this.id,
        code: this.code
      };
    
      self.loading = true;
      this.api.post( 'warranty/validateWarranty', post_data )
      .then(function (response) {

          self.validation_response = response.data;

          
          if( typeof callback === 'function')
            callback();
      })
      .catch(function (error) {
          self.notification.error(error);
      })
      .finally( function(){
        self.loading = false;
      });
    
    },

  },
  computed:{
    
  }
  
}
</script>
